import request from '@/service/lib/request'

/**
 * 昆虫种类
 * @param {String} url 请求地址
 */
export function list(id) {
  return request({
    url: `/api/v1/companies/${id}/categories`,
    method: 'get'
  })
}

/**
 * 昆虫种类
 * @param {String} url 请求地址
 */
export function device(id) {
  return request({
    url: `/api/v1/devices/${id}/categories`,
    method: 'get'
  })
}
